import React from 'react';
import { FcMusic } from 'react-icons/fc';
import { FaEdit, FaTrash } from 'react-icons/fa';

export default function MusicPlayer({ music, onDelete, onEdit, showActions }) {
  return (
    <div className="bg-gray-800 rounded-lg shadow-md overflow-hidden transform transition duration-300 hover:scale-105">
      <div className="p-4">
        {/* Music Title and Icon */}
        <div className="flex items-center mb-3">
          <FcMusic className="text-3xl mr-2" />
          <h3 className="text-lg font-semibold text-white truncate">{music.title}</h3>
        </div>

        {/* Audio Player */}
        <audio
          controls
          src={music.url}
          className="w-full mb-3"
          style={{ height: '40px' }}
        >
          Your browser does not support the audio element.
        </audio>

        {/* Edit/Delete Actions (for admins only) */}
        {showActions && (
          <div className="flex justify-end space-x-2">
            <button
              onClick={() => onEdit(music.id)}
              className="text-sky-400 hover:text-sky-500 transition"
              title="Edit Music"
            >
              <FaEdit size={16} />
            </button>
            <button
              onClick={() => onDelete(music.id)}
              className="text-red-600 hover:text-red-700 transition"
              title="Delete Music"
            >
              <FaTrash size={16} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}